module.exports = __webpack_public_path__ + "static/media/supporter.439c049c.png";